import { render } from "./tab-list-booking.vue?vue&type=template&id=ae0c4764&scoped=true&ts=true"
import script from "./tab-list-booking.vue?vue&type=script&lang=ts"
export * from "./tab-list-booking.vue?vue&type=script&lang=ts"

import "./tab-list-booking.vue?vue&type=style&index=0&id=ae0c4764&scoped=true&lang=css"
import "./tab-list-booking.vue?vue&type=style&index=1&id=ae0c4764&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0c4764"]])

export default __exports__